<app-blockly-variable-dialog />
<p-drawer
  [(visible)]="showPluginsDrawer"
  appendTo="body"
  (onHide)="pluginsDrawerContent.reset()"
  header="Blockly Plugins verwalten"
  [style]="{width: '50vw'}"
  position="right"
>


  <app-blockly-plugins-drawer-content
    #pluginsDrawerContent
    (pluginAdded)="onPluginAdded($event)"
    (pluginDeleted)="onPluginDeleted($event)"
    (openBottly)="this.openBottly()"
  ></app-blockly-plugins-drawer-content>
</p-drawer>

<div
  id="blocklyDiv"
  style=" width: 100%; height:100%; "
></div>